import React from 'react';
import { Typography, Button, Card, CardActions, useMediaQuery, Link } from '@mui/material';
import { Image } from 'cloudinary-react'
import { useDispatch } from "react-redux"
import { addToCart, decreaseCart, removeFromCart } from '../../../features/slices/cartSlice';
import { useGetCartQuery, useUpdateCartMutation } from '../../../features/fullApi';
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';



const CartItem = ({ item }) => {
  const dispatch = useDispatch()
  const [updateCart] = useUpdateCartMutation()

  const user = JSON.parse(localStorage.getItem('user'))
  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user._id);

  const config = {
    headers: {
      token: 'Bearer ' + user?.accessToken
    }
  }

  const handleRemoveFromCart = (cartItem) => {
    dispatch(removeFromCart(cartItem))
    const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
    let newProducts = []
    currentProducts.map(product => {
      newProducts.push({productId: product._id, quantity: product.cartQuantity})
    })
    updateCart({_id: cart._id, products: newProducts}, config)
    .then(res => 
      {    
        toast('Product removed from cart', {
          icon: '❌',
        });
  }).catch(err =>       {    
    
})
};

  const handleIncreaseCart = (product) => {
    dispatch(addToCart(product))
    const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
    let newProducts = []
    currentProducts.map(product => {
      newProducts.push({productId: product._id, quantity: product.cartQuantity})
    })
    updateCart({_id: cart._id, products: newProducts}, {headers: {token: 'Bearer ' + user.accessToken}})
    .then(res => console.log("res", res))
    .catch(err => console.log("err", err))
  }



  const handleDecreaseCart = (product) => {
    dispatch(decreaseCart(product))
    const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
    let newProducts = []
    currentProducts.map(product => {
      newProducts.push({productId: product._id, quantity: product.cartQuantity})
    })
    updateCart({_id: cart._id, products: newProducts})
    .then(res => console.log("res", res))
    .catch(err => console.log("err", err))
  }

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));


  const mobileCartItem = () => (
      <Card style={{display: 'flex', padding: '20px', justifyContent: 'space-between', alignItems:'center', width: '325px', height: '250px'}}>
      <div>
        <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '125px', height: '125px', objectFit:'cover', objectPosition:'center'}}/>
        <div style={{maxWidth: '150px'}}>
        <Typography gutterBottom variant="subtitle1" component="subtitle1" style={{textAlign: 'center'}}>
            {item?.title}
        </Typography>
        </div>
      </div>
    <div style={{display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent:'center'}}>
      <div style={{display: 'flex', justifyContent:'center', alignItems: 'center'}}>
      <Button size="small" style={{textDecoration: 'none', padding: '5px', fontSize: '18px'}} onClick={() => handleDecreaseCart(item)}>-</Button>
       {item.cartQuantity}
      <Button size="small" disabled={item.quantity === item.cartQuantity}  style={{textDecoration: 'none', padding: '5px', fontSize: '13px'}}  onClick={() => handleIncreaseCart(item)}>+</Button>
      
      </div>
      <Typography gutterBottom variant="subtitle1" component="subtitle1">
            ${item?.price}
      </Typography>
      <Button variant="contained" size="small" type="button" color="primary" onClick={() => handleRemoveFromCart(item)} style={{width: '100px'}}>Remove</Button>
    </div>
  </Card>
  )

  const tabletCartItem = () => (
    <div style={{textAlign: 'center', paddingTop: '30px', fontSize: '12px', display: 'flex', justifyContent: 'space-between', width: '100%'}}>
      <Card style={{textAlign: 'center', paddingTop: '30px', fontSize: '12px', display: 'flex', justifyContent: 'center', width: '100%', margin: '0 30px'}}>
      <div >
        <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '250px', height: '250px', objectFit:'cover', objectPosition:'center'}}/>
        <div style={{maxWidth: '250px'}}>
        <Typography gutterBottom variant="h5" component="h5">
            {item?.title}
        </Typography>
        </div>
        <Typography gutterBottom variant="h5" component="h4">
            ${item?.price}
        </Typography>
      </div>
    <CardActions>
      <div>
        <Button type="button" size="small" onClick={() => handleIncreaseCart(item)} style={{fontSize: '18px'}}>+</Button>
        <p style={{textAlign: 'center', fontSize: '18px'}}>{item.cartQuantity}</p>
        <Button type="button" style={{fontSize: '18px'}} size="small" onClick={() => handleDecreaseCart(item)}>-</Button>
      </div>
      <Button variant="contained" type="button" color="secondary" onClick={() => handleRemoveFromCart(item)} style={{width: '150px'}}>Remove</Button>
    </CardActions>
  </Card>
  </div>
)

  const desktopCartItem = () => (
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center', marginTop: '25px'}}>
         
          <div>
            <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '120px', height: '120px', objectFit:'cover', objectPosition:'center'}}/>
          </div>

          <div style={{display: 'flex', width:'300px', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
            <Typography gutterBottom variant="subtitle1" component="h2" sx={{textAlign:'center'}}>
                {item?.title}
            </Typography>
            <Button variant="outlined" type="button" color="primary" style={{width: '100px'}} onClick={() => handleRemoveFromCart(item)}>Remove</Button>
          </div>

          <div style={{display: 'flex'}}>
            <Button size="small" onClick={() => handleDecreaseCart(item)}>-</Button>
            <div>
              <span style={{textAlign: 'center', border:'1px solid #eee', width:'50px', height:'50px', padding:'10px'}}>{item.cartQuantity}</span>
            </div>
            <Button size="small" disabled={item.quantity === item.cartQuantity} onClick={() => handleIncreaseCart(item)}>+</Button>
          </div>

          <div style={{width:'50px'}}>
            <Typography gutterBottom variant="subtitle1" component="h2">
                ${item?.price}
            </Typography>
          </div>
        </div>
  )
  
  return (
    (isXs | isSm) ?  mobileCartItem() : 
    (isMd) ? tabletCartItem() :
    desktopCartItem()
  );
};

export default CartItem;